<div class="input-container">
    <label for="uploads_digitalocean_key" trans>DigitalOcean Key</label>
    <input type="text" id="uploads_digitalocean_key" name="uploads_digitalocean_key" [(ngModel)]="state.server['uploads_digitalocean_key']" required>
</div>

<div class="input-container">
    <label for="uploads_digitalocean_secret" trans>DigitalOcean Secret</label>
    <input type="text" id="uploads_digitalocean_secret" name="uploads_digitalocean_secret" [(ngModel)]="state.server['uploads_digitalocean_secret']" required>
</div>

<div class="input-container">
    <label for="uploads_digitalocean_region" trans>DigitalOcean Region</label>
    <input type="text" id="uploads_digitalocean_region" name="uploads_digitalocean_region" [(ngModel)]="state.server['uploads_digitalocean_region']" required>
</div>

<div class="input-container">
    <label for="uploads_digitalocean_bucket" trans>DigitalOcean Bucket</label>
    <input type="text" id="uploads_digitalocean_bucket" name="uploads_digitalocean_bucket" [(ngModel)]="state.server['uploads_digitalocean_bucket']" required>
</div>